var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"data-name":"telegram social media network chat","id":"telegram_social_media_network_chat","key":1},React.createElement("path",{"d":"M28.59,4.29a2.23,2.23,0,0,0-2.27-.36L3.41,13.1a1.83,1.83,0,0,0,0,3.38l1.48.61a1,1,0,0,0,1.31-.53,1,1,0,0,0-.54-1.31L4.56,14.8l22.51-9a.22.22,0,0,1,.23,0,.24.24,0,0,1,.08.23L23.27,25.21a.4.4,0,0,1-.26.3.39.39,0,0,1-.39-.06l-8-6.24,7.83-7.91a1,1,0,0,0-1.22-1.56L9.75,16.54a1,1,0,1,0,1,1.72l4.83-2.85L13.23,17.8a2,2,0,0,0,.2,3.08l8,6.15a2.4,2.4,0,0,0,1.47.5,2.47,2.47,0,0,0,.83-.15,2.37,2.37,0,0,0,1.52-1.75L29.33,6.47A2.23,2.23,0,0,0,28.59,4.29Z"}))]);
}

Telegram.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Telegram;

Telegram.default = Telegram;
